import React from "react";
import { memoPanel as M, tones } from "../../mock/inferraData";

function withCites(text) {
  const parts = text.split(/(\[[^\]]+\])/g);
  return parts.map((p, i) =>
    p.startsWith("[") ? (
      <span key={i} style={{ color: "var(--green)" }}>{p}</span>
    ) : (
      <span key={i}>{p}</span>
    )
  );
}

export default function MemoPanel() {
  return (
    <div className="card-lift mp" style={{ background: "#fff", border: "1px solid rgba(20,32,27,0.16)", borderRadius: 12, overflow: "hidden", display: "flex", minHeight: 460 }}>
      <div style={{ flexGrow: 1, padding: "34px 42px", display: "flex", flexDirection: "column", gap: 16, minWidth: 0 }}>
        <div style={{ fontSize: 12, color: "#5a646e" }}>{M.kicker}</div>
        <div className="font-type" style={{ fontSize: 25, lineHeight: 1.2 }}>{M.title}</div>
        {M.sections.map((s) => (
          <div key={s.h} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--green)" }}>{s.h}</div>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>{withCites(s.p)}</p>
          </div>
        ))}
        {M.bars.map((b) => (
          <div key={b.h} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--green)" }}>{b.h}</div>
            {b.widths.map((w, i) => (
              <div key={i} style={{ height: 7, width: `${w}%`, borderRadius: 3, background: "#e8ebe8", transformOrigin: "left", animation: `bar-grow .9s cubic-bezier(.16,1,.3,1) ${0.1 + i * 0.1}s both` }} />
            ))}
          </div>
        ))}
      </div>

      <div className="mp-side" style={{ width: 250, flexShrink: 0, padding: "28px 22px", borderLeft: "1px solid #e6e9e6", background: "#fafbfa", display: "flex", flexDirection: "column", gap: 20, fontSize: 13 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ fontWeight: 600 }}>Sources cited</div>
          {M.sources.map((s) => (
            <div key={s} style={{ color: "#45514a", lineHeight: 1.45 }}>{s}</div>
          ))}
        </div>
        <div style={{ height: 1, background: "#e6e9e6" }} />
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ fontWeight: 600 }}>Sign-off</div>
          {M.signoff.map(([k, v, tone]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
              <span style={{ color: "#5a646e" }}>{k}</span>
              <span style={{ color: tones[tone] || "inherit" }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ flexGrow: 1 }} />
        <a href="#how" className="btn btn--outline" style={{ height: 44, borderRadius: 6, fontSize: 13.5 }}>Open audit trail</a>
      </div>

      <style>{`
        @media (max-width: 760px) {
          .mp { flex-direction: column; }
          .mp-side { width: 100%; border-left: none; border-top: 1px solid #e6e9e6; }
        }
      `}</style>
    </div>
  );
}
